import { boltApi } from 'store/queries/bolt-api'
import { GetFeedbackWidgetsPayload, GetFeedbackWidgetsResponse } from './types.ts'
import { Flow, Severity } from 'types/logging.ts'
import { createErrorTransformer } from 'store/queries/utils.ts'

export const userBoltApi = boltApi.injectEndpoints({
  endpoints: (builder) => ({
    // GET FEEDBACK WIDGETS BY SLUG
    getFeedbackWidgetBySlug: builder.query<GetFeedbackWidgetsResponse, GetFeedbackWidgetsPayload>({
      query: ({ slug }) => ({
        url: `/feedback-widgets/${slug}`
      }),
      transformResponse: ({ data }) => {
        return data
      },
      transformErrorResponse: createErrorTransformer(`[${Flow.FEEDBACK_WIDGETS}:getFeedbackWidgetBySlug]`, { severity: Severity.WARNING })
    })
  })
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetFeedbackWidgetBySlugQuery } = userBoltApi
